<template>
  <div id="container">
    <div id="dashboard_container" style=" width: 100%; height: 100%;">
      <div class="header">
        <div class="header_title">
          <div class="header_time">
            {{ nowTime }}
          </div>
          <a v-if="proj_flag" href="javascript:void(0)">{{ project_name }}</a>
          <a v-else href="javascript:void(0)" @click="$router.push({path: '/Constractor'})">
            {{ project_name }}
          </a>
          <div class="header_right">
            <span style="color: #ccc;margin-right: 3px">Welcome {{ user }}</span>
            <el-dropdown @command="handleCommand">
              <el-button icon="el-icon-user" circle size="medium"
                         style="background-color:#404040;color:#aaaaaa;border-width: 0"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">Change Password</el-dropdown-item>
                <el-dropdown-item :command="3">Change Project</el-dropdown-item>
                <!--<el-dropdown-item @click.native="$router.push({path: '/login'})">Login Out</el-dropdown-item>-->
                <el-dropdown-item :command="2">Logout</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="header_medium">
          <div class="left">
            <a class="item active one" href="javascript:void(0)" @click="jump('1')">Project</a>
            <a v-show="showman" class="item two" href="javascript:void(0)" @click="jump('2')">Resources</a>
            <a v-show="false" class="item three" href="javascript:void(0)"
               @click="jump('3')">Equipment</a>
            <a v-show="showsafe" class="item four" href="javascript:void(0)" @click="jump('4')">Safety</a>
            <a v-show="showstat" class="item five" href="javascript:void(0)"
               @click="jump('5')">Statistics</a>
          </div>
          <div class="medium">
            {{ startTimes }}
          </div>
          <div class="right">
            <a v-show="showhcs" class="item six" href="javascript:void(0)" @click="jump('6')">SCS</a>
            <a v-show="showdfma" class="item seven" href="javascript:void(0)"
               @click="jump('7')">DfMA</a>
            <a v-show="showrfirfa" class="item eight" href="javascript:void(0)"
               @click="jump('8')">RFI/RFA</a>
            <a v-show="showquailty" class="item nine" href="javascript:void(0)"
               @click="jump('9')">QAQC</a>
            <a v-show="showtower" class="item ten" href="javascript:void(0)"
               @click="jump('10')">TowerCrane</a>
          </div>
        </div>
        <div class="header_medium header_medium_second" v-show="showsecond">
          <div class="left">
            <a v-show="showworkforce" class="item eleven" href="javascript:void(0)" @click="jump('11')">Workforce</a>
            <a v-show="showequipment" class="item twelve" href="javascript:void(0)" @click="jump('12')">Equipment</a>
          </div>
        </div>
      </div>

      <div class="db_body">
        <db_body v-if="index == 1" style="width: 100%; height: 100%;"></db_body>
        <safety_manage v-bind:project_id="project_id" v-else-if="index == 4"
                       style="width: 100%; height: 100%;"></safety_manage>
        <Shellcharts v-bind:project_id="project_id" v-else-if="index == 5"
                     style="width: 100%; height: 100%;"></Shellcharts>
        <HCS v-bind:my_project_id="project_id" v-bind:project_name="project_name" v-else-if="index == 6"
             style="width: 100%; height: 100%;"></HCS>
        <Fbaric v-bind:project_id="project_id" v-else-if="index == 7"
                style="width: 100%; height: 100%;"></Fbaric>
        <Rfirfa v-bind:project_id="project_id" v-else-if="index == 8"
                style="width: 100%; height: 100%;"></Rfirfa>
        <quality v-bind:project_id="project_id" v-else-if="index == 9"
                 style="width: 100%; height: 100%;"></quality>
        <towercrane v-bind:project_id="project_id" v-else-if="index == 10"
                    style="width: 100%; height: 100%;"></towercrane>
        <workforce v-bind:project_id="project_id" v-else-if="index == 11"
                   style="width: 100%; height: 100%;"></workforce>
        <manequipment v-bind:project_id="project_id" v-else-if="index == 12"
                      style="width: 100%; height: 100%;"></manequipment>
      </div>
    </div>

    <el-dialog title="Change Project" :visible.sync="changeProjectFormVisible">
      <el-radio-group @change="handleProjectChange" v-model="pro_index">
        <el-radio v-for="(project, index) in pros" :key="index" :label="index">{{ project.project_name }}</el-radio>
      </el-radio-group>
    </el-dialog>
  </div>
</template>

<script>

import body from "@/components/body"
import safety_manage from '@/components/safety_manage/safety_manage'
import quality from '@/components/quality/quality'
import towercrane from '@/components/towercrane/towercrane'
import Shellcharts from "@/components/shellcharts/shellcharts"
import HCS from '@/components/hcs/main'
import Rfirfa from '@/components/rfirfa/main'
import Fbaric from '@/components/fabrication/quality'
import workforce from "@/components/manpower/workforce";
import manequipment from "@/components/manpower/manequipment";
import axios from 'axios'

export default {
  name: "dashboard",
  data() {
    return {
      nowTime: '',
      startDate: '2018-08-15',
      startTimes: '',
      index: 1,
      items: [],
      company: '',
      container: '',
      project_name: '',
      project_id: '',
      proj_flag: true,
      screenWidth: document.documentElement.clientWidth,
      screenHeight: document.documentElement.clientHeight,
      showman: false,
      showequip: false,
      showsafe: false,
      showdfma: false,
      showtower: false,
      showstat: false,
      showrfirfa: false,
      showhcs: false,
      showquailty: false,

      showsecond: false,
      showworkforce: false,
      showequipment: false,
      user: window.localStorage.getItem("token_key"),
      second_index: 0,
      role: window.localStorage.getItem("role"),

      changeProjectFormVisible: false,
      pros: JSON.parse(window.localStorage.getItem('pros')),
      pro_index: parseInt(window.localStorage.getItem('pro_index'))
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 1) {
        this.$router.push("/changepwd")
      } else if (command === 2) {
        window.localStorage.clear();
        this.$router.push("/login")
        history.pushState(null, null, document.URL)
        window.addEventListener(
          "popstate",
          function (e) {
            history.pushState(null, null, document.URL)
          },
          false
        )
      } else if (command === 3) {
        this.changeProjectFormVisible = true
      }
    },
    setRootSize() {
      this.container.style.width = 1440 + 'px'
      this.container.style.height = 800 + 'px'
      this.container.style.fontSize = 80 + 'px'
    },
    handleProjectChange(index) {
      this.changeProjectFormVisible = false
      var project = this.pros[index]
      window.localStorage.setItem('pro_index', index)
      window.localStorage.setItem('bes_project_id', project.bes_project_id)
      this.$router.push('/dashboard?proj_id=' + project.c_project_id)
      this.refresh(this.$route.path)
    },
    refresh(url) {
      //判断是否是当前路由
      if(url == this.$route.path) {
        this.$router.push({
          path: 'redirect',
          query: this.$route.fullPath
        })
      } else {
        this.$router.push({
          path: url
        })
      }
    },
    init() {
      this.items = document.querySelectorAll('.header_medium .item')
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].dataset.order = i + 1
      }
      this.getProInfo()
    },
    getProInfo() {
      let postData = {
        project_id: this.project_id,
        user: window.localStorage.getItem("token_key"),
        token: window.localStorage.getItem('token')
      };
      axios.post(this.$store.getters.getCmsServer + "DBProjMsg", postData).then(resp => {
        let errNo = resp.data.errno;
        let errStr = resp.data.errstr_cn;
        if (errNo == "0") {
          let result = resp.data.result
          this.project_name = result[0].proj_name
          var name = window.localStorage.getItem('token_key')
          if ("videmo" == name) {
            this.project_name = "HDB Vision Demo"
          }
        } else {
          alert("get some error:" + errStr)
          this.project_name = "Test Project"
        }
      })
    },
    menu_show() {
      var model_list = window.localStorage.getItem("model_list").split("|")
      if (model_list.indexOf("all") >= 0) {
        this.showsafe = true
        this.showhcs = true
        this.showdfma = true
        this.showrfirfa = true
        this.showman = true
        this.showstat = true
        this.showquailty = true
        this.showtower = true
        this.showequip = true
        this.showworkforce = true
        this.showequipment = true
        this.proj_flag = false
      }
      if (model_list.indexOf("safety") < 0) {
        this.showsafe = true
      }
      if (model_list.indexOf("hcs") >= 0) {
        this.showhcs = true
      }
      if (model_list.indexOf("dfma") >= 0) {
        this.showdfma = true
      }
      if (model_list.indexOf("rfirfa") >= 0) {
        this.showrfirfa = true
      }
      if (model_list.indexOf("manpower") < 0) {
        this.showman = true
      }
      if (model_list.indexOf("statistics") < 0) {
        this.showstat = true
      }
      if (model_list.indexOf("quality") < 0) {
        this.showquailty = true
      }
      if (model_list.indexOf("towercrane") < 0) {
        this.showtower = true
      }
      if (model_list.indexOf("equipment") < 0) {
        this.showequip = true
      }
      if (model_list.indexOf("workforce") < 0) {
        this.showworkforce = true
      }
      if (model_list.indexOf("man_equipment") < 0) {
        this.showequipment = true
      }
    },
    timeFormat(timeStamp) {
      let week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      let year = new Date(timeStamp).getFullYear();
      let month = months[new Date(timeStamp).getMonth()];
      let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
      let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
      let weekday = week[new Date(timeStamp).getDay()];
      this.nowTime = date + " " + month + " " + year + " " + hh + ":" + mm + ":" + ss + " " + weekday;
      let startDate = Date.parse(this.startDate)
      let dateSpan = startDate - timeStamp
      dateSpan = Math.abs(dateSpan)
      this.startTimes = "Safety Man-hours：" + Math.floor(dateSpan / (24 * 3600 * 1000)) + " d " + hh + " h " + mm + " m " + ss + " s"
    },
    nowTimes() {
      this.timeFormat(new Date());
    },
    jump(clickIndex) {
      // this.$router.push('/safety_manage')
      this.index = clickIndex
      this.showsecond = false
      if (clickIndex == '2') {
        this.showsecond = true
        if (this.second_index == 0) {
          this.index = 11
          clickIndex = 11
        } else {
          this.index = 12
          clickIndex = 12
        }
      }
      let activeItem = document.querySelector('.header_medium .active')
      let activeIndex = activeItem.dataset.order
      let clickItem = this.items[clickIndex - 1]
      if (activeIndex == clickIndex) {
        return
      }
      activeItem.classList.remove('active')
      clickItem.classList.add('active')
      if (clickIndex == '11') {
        this.second_index = 0
        this.showsecond = true
        this.items[1].classList.add('active')
        this.items[11].classList.remove('active')
      }
      if (clickIndex == '12') {
        this.second_index = 1
        this.showsecond = true
        this.items[1].classList.add('active')
        this.items[10].classList.remove('active')
      }
    }
  },
  components: {
    Shellcharts,
    'db_body': body,
    safety_manage,
    quality,
    towercrane,
    HCS,
    Rfirfa,
    Fbaric,
    workforce,
    manequipment
  },
  mounted() {
    this.project_id = this.$route.query.proj_id
    this.timer = setInterval(this.nowTimes, 1000);
    this.init()
    this.container = document.getElementById('dashboard_container')
    this.setRootSize()

    window.onresize = () => {
      this.screenWidth = document.documentElement.clientWidth
      this.screenHeight = document.documentElement.clientHeight
      this.setRootSize()
    }
  },
  created() {
    this.menu_show()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
html, body, #container {
  height 100%
  width 100%
  background #24293c
  overflow auto
  margin 0 auto
}

#dashboard_container {
  position relative
  margin: auto;
  overflow hidden
}

.header {
  width: 100%;
  height: 18%;
  position: relative
  font-size 0.35em
}

.header_title {
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 1em;
  color: #EEE;
  background: url("../assets/top_bg.png") center center / 100%;
}

.header_title .el-dropdown {
  padding: 0;
  border-radius: 0;
}

.header_time {
  background: #404040;
  color: #aaaaaa;
  position: absolute;
  top: 20%;
  left: 0;
  padding-left 1%
  padding-right 1%
  font-size: 0.5em;
  text-align: center;
  border: 4px whitesmoke;
  border-radius: 5px;
}

.header_right {
  position: absolute;
  top: 20%;
  right: 0;
  padding-left 1%
  padding-right 1%
  font-size: 0.5em;
  text-align: center;
  border: 4px whitesmoke;
  border-radius: 5px;
}

.header_medium {
  position: absolute;
  top: 35%;
  width: 100%;
  height: auto;
  text-align: center;
  font-size: 0.5em;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.header_medium_second {
  top: 67%;
  width: 50%;
}

.header_project {
  position: absolute
  top: 60%
  left: 50%
  transform: translateX(-50%);
  width: auto
  height: 25%
  font-size 0.9em
}

.left {
  position: relative;
  width: 40%;
  height: 100%;
  background-color: #41455D;
  display: flex;
  font-size 1em
  align-items flex-end
  justify-content: space-around;
  color: #ccc !important;
}

.medium {
  position: relative;
  background-color: transparent;
  display: flex;
  font-size 1em
  justify-content: space-around;
  color: #595959 !important;
}

.right {
  position: relative;
  width: 40%;
  height: 100%;
  background-color: #41455D;
  font-size 1em
  display: flex;
  align-items flex-end
  justify-content: space-around;
}

a:active {
  border-bottom: 1px solid #08a5df;
  color: #08a5df !important
}

a {
  width: 25%;
  color: #a7a7a7;
  font-size: 1.2em;
  padding-top 1%
  padding-bottom 1%
  text-decoration: none;
}

.active {
  border-bottom: 1px solid #08a5df;
  color: #08a5df !important;
}

.db_body {
  height: 83%;
  width: 100%;
  position: relative;
  text-align: center;
  margin 0 auto
  font-size 1em
  top: -2%
  z-index 2
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue